module.exports = {
    GOOGLE_MAPS_API_KEY: "AIzaSyDrbv2S_e_nqZNuRiaSsccFBDPuOiYlNYI"
};
